import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { MuiThemeProvider } from 'material-ui/styles';
import { withStyles } from 'material-ui/styles';
import { objectValues } from 'shared/utils/src/object';
import { withRouter } from 'react-router-dom'

import Paper from 'material-ui/Paper';
import Header from 'components/Header';
import CreateKeyModal from 'components/CreateKeyModal'

import lightTheme from 'themes/light';
import darkTheme from 'themes/dark';

import { THEME } from '-enums';

import moment from 'moment';
import 'moment/locale/ru';

import * as routes from 'routes/config';

import withAppStore from 'decorators/withAppStore';
import inject from 'helpers/inject'
import RouterService from 'services/router'

import styles from 'styles/components/App';

moment.locale('ru');

@withStyles(styles)
@withRouter
@withAppStore
@observer
class App extends Component {

  router = inject(RouterService)

  @computed
  get theme() {
    switch (this.appStore.theme) {
      case THEME.LIGHT:
        return lightTheme;
      case THEME.DARK:
        return darkTheme;
      default:
        throw new Error('Invalid theme');
    }
  }

  componentDidMount() {
    const { match, history, location } = this.props
    this.router.bind({ match, history, location })
  }

  render() {
    const { classes } = this.props;
    return (
      <MuiThemeProvider theme={ this.theme }>
        <Paper elevation={0} square className={ classes.root }>
          <Header />
          { objectValues(routes).map((route, index) => (
            <Route path={ route.path } exact={ route.exact } component={ route.component } key={ index } />
          ))}
          <CreateKeyModal />
        </Paper>
      </MuiThemeProvider>
    );
  }

}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js